import { Box, Button } from "@mui/material";
import React, { useRef } from "react";
import Barcode from "react-barcode";
import { useReactToPrint } from "react-to-print";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";

const BarcodeGenerate = ({ list, showVarientName = false }) => {
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });

  return (
    <>
      {list?.length > 0 && (
        <>
          <Box
            sx={{
              background: "#F9FAFB",
              py: 2,
              maxHeight: "500px",
              overflowX: "auto",
            }}
          >
            <Box ref={contentRef}>
              {list?.length > 0 &&
                list
                  ?.sort((a, b) => a.sku_number - b.sku_number)
                  ?.map((item, i) => {
                    const variationName =
                      item?.product_variation_data?.[0]?.name;

                    return (
                      <Box
                        key={i}
                        sx={{
                          display: "inline-flex",
                          flexDirection: "column",
                          alignItems: "center",
                          margin: "0px 10px",
                          textAlign: "center",
                        }}
                      >
                        {showVarientName && variationName && (
                          <Box
                            component="span"
                            sx={{ fontSize: "12px", fontWeight: 500, mb: 0.5 }}
                          >
                            {variationName}
                          </Box>
                        )}
                        <Barcode
                          value={item?.sku_number}
                          width={2}
                          height={30}
                        />
                      </Box>
                    );
                  })}
            </Box>
          </Box>
          <Box sx={{ py: 2, textAlign: "right" }}>
            <Button
              variant="contained"
              sx={{ width: "150px" }}
              startIcon={<LocalPrintshopOutlinedIcon />}
              onClick={handlePrint}
            >
              Print
            </Button>
          </Box>
        </>
      )}
    </>
  );
};

export default BarcodeGenerate;
